import React, { useState, useEffect } from 'react';
import { Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import ListadoDocumentos from '../listadoDocumentos/ListadoDocumentos';
import BuscarDocumentos from '../buscarDocumentos/BuscarDocumentos';
import PaginarDocumentos from '../listadoDocumentos/PaginarDocumentos';
import { clearErrors } from '../../actions';
import {
  ValidarEmisor,
  ValidarLogin,
  getCurrentDate,
  addDayToDate,
  getCasaMatriz
} from '../../util';
import { documentTypeEnum } from '../../enum';

const NotasCredito = (props) => {
  const { token } = ValidarLogin(props);
  const { emisor } = ValidarEmisor(props);
  const { notasCreditoState } = props;
  const [documentos, setDocumentos] = useState([]);
  const [totalRegistros, setTotalRegistros] = useState(0)
  const [pageSize, setPageSize] = useState(15);
  const [request, setRequest] = useState({
    Identificacion: emisor?.Identificacion.Numero,
    CasaMatriz: getCasaMatriz(emisor?.usuario),
    FechaInicio: addDayToDate(getCurrentDate(), -30),
    FechaFin: addDayToDate(getCurrentDate(), + 1),
    NumeroPagina: 1,
    TamanoPagina: 15
  });

  useEffect(() => {
    props.clearErrors();
  }, []);

  useEffect(() => {
    if (notasCreditoState !== null) {
      setDocumentos(notasCreditoState.facturas.DocumentosElectronicos);
      setTotalRegistros(notasCreditoState.facturas.TotalRegistros);
    }
  }, [notasCreditoState]);

  if (token === null) {
    return <Redirect to='/login' />;
  }

  const onNextPage = (pageNumber) => {
    setRequest({
      ...request,
      NumeroPagina: pageNumber,
      TamanoPagina: pageSize
    });
  };

  return (
    <div className="ui Lista-facturas-container">
      <div className="ui right aligned grid">
        <div className="column">
          <span className="ui green tag label">
            <h3>NOTAS DE CRÉDITO</h3>
          </span>
        </div>
      </div>
      <BuscarDocumentos docType={documentTypeEnum.NotaCredito} token={token} emisor={emisor} numeroPagina={request.NumeroPagina} tamanoPagina={request.TamanoPagina} />
      <ListadoDocumentos documentos={documentos} docType={documentTypeEnum.NotaCredito} token={token.access_token} />
      <PaginarDocumentos pageSize={pageSize} totalRegistros={totalRegistros} onGetNextPage={(pageNumber) => {
        onNextPage(pageNumber);
      }} />
    </div>
  )
};

const mapStateToProps = (state) => {
  return {
    loginState: state.loginState,
    emisorState: state.emisorState,
    notasCreditoState: state.notasCreditoState,
  };
};

export default connect(mapStateToProps, { clearErrors })(NotasCredito);